import { Controller } from "@hotwired/stimulus"

// Filter box inside a long dropdown menu — what select2 used to give the
// tournament switcher, without jQuery or select2.
//
// Rendered by the Dropdown component when `searchable:` is set and the menu has
// enough items.
export default class extends Controller {
    static targets = ["input", "empty"]

    // Bootstrap fires this on the dropdown when it opens.
    focus() {
        this.inputTarget.value = ""
        this.filter()
        // The menu animates in; focusing on the next frame actually lands.
        requestAnimationFrame(() => this.inputTarget.focus())
    }

    filter() {
        const term = this.inputTarget.value.trim().toLowerCase()
        let visible = 0

        this.items.forEach((item) => {
            const match = !term || item.textContent.toLowerCase().includes(term)
            item.hidden = !match
            if (match) visible += 1
        })

        if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
    }

    // Enter opens the first remaining match; Escape clears before Bootstrap
    // closes the whole menu.
    keydown(event) {
        if (event.key === "Enter") {
            const first = this.items.find((item) => !item.hidden)?.querySelector("a")
            if (first) {
                event.preventDefault()
                first.click()
            }
        } else if (event.key === "Escape" && this.inputTarget.value) {
            event.stopPropagation()
            this.inputTarget.value = ""
            this.filter()
        }
    }

    // Clicking the input would otherwise bubble up and close the menu.
    swallow(event) {
        event.stopPropagation()
    }

    // Every menu entry except the search row and the "no matches" row.
    get items() {
        return Array.from(this.element.querySelectorAll(".dropdown-menu > li"))
                    .filter((li) => !li.classList.contains("dropdown-search") &&
                                    !li.classList.contains("dropdown-search__empty"))
    }
}
